export default __webpack_public_path__ + "static/media/successframe.c6c3da41.png";